<template lang="">
  <div style="position: relative;">
    <div class="hometop"> 
      <!-- <div class="homece">
        <a href="/home" class="cn">中文</a> | <a href="/en/home">ENGLISH</a>
      </div> -->
      <div class="home_logo">
        <router-link to="/"><img src="@/assets/images/head_logo.png"></router-link>
      </div>
      <div id="header_title">
        <span>
          <p>
            <router-link :style="dynamicStyle" to="/home" active-class="current">首页</router-link>
          </p>
        </span>

        <!--走进中磊-->
        <span  @mouseover="About('about')" @mouseleave="showAbout=true">
          <p>
            <router-link :style="dynamicStyle" v-if="aboutList.length" active-class="current"
              :to="{path:'/about',query:{category_id:aboutList[0].id}}">走进中磊</router-link>
          </p>
          <ul v-if="aboutList.length" :class="{ isShow: !showAbout && $route.path==='/home' }">
            <li v-for="(item,index) in aboutList" :key="index">
              <router-link v-if="item.id!==5&&item.id!==7&&item.id!==8"
                :to="{path:'/about',query:{category_id:item.id}}">{{item.title}}</router-link>
              <router-link v-else-if="item.id==5"
                :to="{path:'/honor',query:{category_id:item.id}}">{{item.title}}</router-link>
              <router-link v-else-if="item.id==7"
                :to="{path:'/partner',query:{category_id:item.id}}">{{item.title}}</router-link>
              <router-link v-else-if="item.id==8"
                :to="{path:'/video',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </ul>
        </span>
       

        <!--产品中心-->
        <span @mouseover="Product('product')" @mouseleave="showProduct=true">
          <p><router-link v-if="productList.length" active-class="current" :style="dynamicStyle"
              :to="{path:'/product',query:{category_id:productList[0].id}}">中磊产品</router-link></p>
          <ul v-if="productList.length" :class="{ isShow: !showProduct&& $route.path==='/home' }">
            <li v-for="(item,index) in productList" :key="index">
              <router-link :to="{path:'/product',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </ul>
        </span>
        

        <!--案例中心-->
        <span @mouseover="Case('case')" @mouseleave="showCase=true">
          <p><router-link v-if="caseList.length" active-class="current" :style="dynamicStyle"
              :to="{path:'/case',query:{category_id:caseList[0].id}}">工程案例</router-link></p>
          <ul :class="{ isShow: !showCase && $route.path==='/home' }">
            <li v-for="(item,index) in caseList" :key="index">
              <router-link :to="{path:'/case',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </ul>
        </span>

           <!--新闻动态-->
           <span @mouseover="News('news')" @mouseleave="showNews=true">
            <p><router-link v-if="newsList.length" active-class="current" :style="dynamicStyle"
                :to="{path:'/news',query:{category_id:newsList[0].id}}">新闻动态</router-link></p>
            <ul :class="{ isShow: !showNews && $route.path==='/home'}">
              <li v-for="(item,index) in newsList" :key="index">
                <router-link :to="{path:'/news',query:{category_id:item.id}}">{{item.title}}</router-link>
              </li>
            </ul>
          </span>

          <!--生产工艺-->
        <span @mouseover="Crafts('crafts') " @mouseleave="showCrafts=true">
          <p><router-link v-if="craftsList.length" active-class="current" :style="dynamicStyle"
              :to="{path:'/crafts',query:{category_id:craftsList[0].id}}">生产工艺</router-link></p>
          <ul :class="{ isShow: !showCrafts && $route.path==='/home' }">
            <li v-for="(item,index) in craftsList" :key="index">
              <router-link :to="{path:'/crafts',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </ul>
        </span>
        
     

        <!--联系我们-->
        <span @mouseover="Contact('contact')" @mouseleave="showContact=true">
          <p><router-link v-if="contactList.length" active-class="current" :style="dynamicStyle"
              :to="{path:'/contact',query:{category_id:contactList[0].id}}">联系我们</router-link></p>
          <ul :class="{ isShow: !showContact && $route.path==='/home'}">
            <li v-for="(item,index) in contactList" :key="index">
              <router-link v-if="item.id!==2" :to="{path:'/contact',query:{category_id:item.id}}">{{item.title}}</router-link>
              <router-link v-else :to="{path:'/message',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </ul>
        </span>
      
      </div>
    </div>
    <div>
      <div :class="{mindir_div:true,isShow: $route.path!=='/home'}" style="z-index:-1">
        <div style="width: 1060px; margin: 0 auto; position: relative;">
        </div>
      </div>
      <div class="mindir_div" style="display:block;background:none">

        <div style="width: 1060px; margin: 0 auto; position: relative;">
          <div  :class="{ mindir:true, isShow: activeSection==='about' && $route.path!=='/home' }">
            <li v-for="(item,index) in aboutList" :key="index" >
              <router-link v-if="item.id!==5&&item.id!==7&&item.id!==8" :to="{path:'/about',query:{category_id:item.id}}">{{item.title}}</router-link>
              <router-link v-else-if="item.id==5" :to="{path:'/honor',query:{category_id:item.id}}">{{item.title}}</router-link>
              <router-link v-else-if="item.id==7" :to="{path:'/partner',query:{category_id:item.id}}">{{item.title}}</router-link>
              <router-link v-else-if="item.id==8" :to="{path:'/video',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </div>
          <div class="mindir"  :class="{ isShow: activeSection==='product' && $route.path!=='/home' }">
            <li v-for="(item,index) in productList" :key="index" >
              <router-link :to="{path:'/product',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </div>
          <div class="mindir"  :class="{ isShow: activeSection==='case' && $route.path!=='/home' }">
            <li v-for="(item,index) in caseList" :key="index" >
              <router-link :to="{path:'/case',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </div>
          <div class="mindir"   :class="{ isShow: activeSection==='crafts' && $route.path!=='/home' }">
            <li v-for="(item,index) in craftsList" :key="index" >
              <router-link :to="{path:'/crafts',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </div>
          <div class="mindir"  :class="{ isShow: activeSection==='news' && $route.path!=='/home'}">
            <li v-for="(item,index) in newsList" :key="index" >
              <router-link :to="{path:'/news',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </div>
          <div class="mindir"  :class="{ isShow: activeSection==='contact' && $route.path!=='/home'}">
            <li v-for="(item,index) in contactList" :key="index" >
              <router-link v-if="item.id!==2" :to="{path:'/contact',query:{category_id:item.id}}">{{item.title}}</router-link>
              <router-link v-else :to="{path:'/message',query:{category_id:item.id}}">{{item.title}}</router-link>
            </li>
          </div>
        </div>


        
      </div>
    </div>
    <div :class="{topbg:$route.path!=='/home'}"></div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        activeSection: null, // 当前激活的<p>标签
        showAbout:true,
        showProduct:true,
        showCase:true,
        showCrafts:true,
        showContact:true,
        showNews:true,
        aboutList: [],
        productList: [],
        caseList: [],
        craftsList: [],
        newsList:[],
        contactList: [],
        messageList:[],
      }
    },
    mounted() {
      this.getAboutList();
      this.getProductList();
      this.getCases();
      this.getNews();
      this.getCrafts();
      this.getContact();
    },
    computed:{
      dynamicStyle() {
      return {
        color: this.$route.path !== '/home' ? '#727171' : ' #195c99'
      };
    }
    },
    methods: {
      async getAboutList() {
        const res = await this.$request.post('about/getAll')
        if (res.data.code === 0) {
          this.aboutList = res.data.data
        }
      },
      async getProductList() {
        const res = await this.$request.post('productcategory/getAll')
        if (res.data.code === 0) {
          this.productList = res.data.data
        }
      },
      async getCases() {
        const res = await this.$request.post('casescategory/getAll')
        if (res.data.code === 0) {
          this.caseList = res.data.data
        }
      },
      async getNews() {
        const res = await this.$request.post('newscategory/getAll')
        if (res.data.code === 0) {
          this.newsList = res.data.data
        }
      },
      async getCrafts() {
        const res = await this.$request.post('crafts/getAll')
        if (res.data.code === 0) {
          this.craftsList = res.data.data
        }
      },
      async getContact() {
        const res = await this.$request.post('contact/getAll')
        if (res.data.code === 0) {
          this.contactList = res.data.data
        }
      },
      About(section){
        this.showAbout = false;
        this.activeSection = section;
      },
      Product(section){
        this.showProduct = false
        this.activeSection = section;
      },
      Case(section){
        this.showCase = false
        this.activeSection = section;
      },
      News(section){
        this.showNews = false
        this.activeSection = section;
      },
      Crafts(section){
        this.showCrafts= false
        this.activeSection = section;
      },
      Contact(section){
        this.showContact= false
        this.activeSection = section;
      }
    },
  }
</script>
<style lang="css" scoped>
   .isShow {
    display: block !important;
  }
   .homeBlue{
    color: #195c99;
   }
  
</style>